import type { MutableRefObject } from 'react';

import { Canvas } from '../../core/components/canvas/Canvas.js';
import { CanvasContext } from '../../core/components/canvas/CanvasContext.js';
import type { CanvasShape } from '../../core/components/canvas/types/canvas-shape.js';
import { plotLayout } from '../../core/components/chart-grid/ChartGrid.sty.js';
import { useGridPlotSize } from '../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { DotDisplay } from '../components/displays/DotDisplay.js';
import { RectDisplay } from '../components/displays/RectDisplay.js';
import { useXYChartScales } from '../hooks/useXYChartScales.js';
import { useXYChartHighlightedSeriesIdsState } from '../store/selectors.js';

export function XYChartLayout() {
  const { height, width } = useGridPlotSize();
  const highlightedSeriesIds = useXYChartHighlightedSeriesIdsState();
  const axisIdToScales = useXYChartScales();

  return (
    <div className={plotLayout}>
      {/* Consider refactor Canvas, and move context inside Canvas */}
      <CanvasContext.Provider
        value={{
          shapeRefs: new Map<string, MutableRefObject<CanvasShape>>(),
        }}
      >
        <Canvas width={width} height={height}>
          <RectDisplay axisIdToScales={axisIdToScales} />
          <DotDisplay
            axisIdToScales={axisIdToScales}
            highlightedSeriesIds={highlightedSeriesIds}
          />
        </Canvas>
      </CanvasContext.Provider>
    </div>
  );
}

XYChartLayout['displayName'] = 'XYChartLayout';
